import { html } from '@shared/utils/rendering/html';

import SystemDetails from './system-details';
import SystemsTable from './systems-table';

const AdminSystems = ({ systemId }) => {
    if (systemId) {
        return html`<${SystemDetails} remoteSystemId=${systemId} />`;
    }

    return html`<${SystemsTable} />`;
};

export default AdminSystems;
